import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Button } from "react-bootstrap";
import "../../styles/depots/depots.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import DepotMap from "../maps/depotMap";
import HtmlContent from "../commoncomponents/htmlContent";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { searchSuggestionAPI, GeoCodeAPI } from "../../utils/mapapi";

class CreateDepot extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      name: "",
      timeZoneArr: [],
      timeZoneName: "",
      description: "",
      error: false,
      timeZoneId: "",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      lat: "",
      lng: "",
      customerError: false,
      nameError: false,
      descriptionError: false,
      timeZoneError: false,
      mapOverlayError: false,
    };
    this.circleLat = "";
    this.circleLng = "";
    this.circleRad = "";
    this.polygonArr = [];
    this.rectLat1 = "";
    this.rectLat2 = "";
    this.rectLng1 = "";
    this.rectLng2 = "";
    this.type = "";
  }

  async componentDidMount() {
    this.getCustomers();
    this.getTimeZone();
  }

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getTimeZone = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "default") {
      this.setState({
        timeZoneError: true,
        timeZoneId: "",
        timeZoneName: "",
      });
    } else {
      this.setState({ timeZoneError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({
          timeZoneId: time.timeZonesId,
          timeZoneName: time.timeZoneCity,
        });
      }
    });
  };

  handleCustomer = (evt) => {
    if (evt.target.value == "default") {
      this.setState({
        customerError: true,
        customerId: "",
        customerName: "",
      });
    } else {
      this.setState({ customerError: false });
    }
    this.state.customers.forEach((customer) => {
      if (customer.name == evt.target.value) {
        this.setState({
          customerId: customer.id,
          customerName: customer.name,
        });
      }
    });
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleArrCreation = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i] == 0) data.splice(i, 1);
    }
    var requiredArr = [];
    for (let i = 0; i < data.length; i = i + 2) {
      const coordinateObj = {
        lat: data[i],
        lng: data[i + 1],
      };
      requiredArr.push(coordinateObj);
    }

    return requiredArr;
  };

  handleCircleCreate = (data) => {
    this.circleLat = data.lat;
    this.circleLng = data.lng;

    this.circleRad = data.rad;
    this.type = "circle";
  };

  handlePolygonCreate = (data) => {
    this.polygonArr = data;
    this.type = "polygon";
  };

  handleRectangleCreate = (data) => {
    this.type = "rectangle";
    this.rectLat1 = data.lat1;
    this.rectLat2 = data.lat2;
    this.rectLng1 = data.lng1;
    this.rectLng2 = data.lng2;
  };

  handleCreate = async () => {
    const { name, description, customerId, timeZoneId } = this.state;
    const obb = {
      name: name,
      description: description,
      customerId: customerId,
      timeZonesId: timeZoneId,
    };
    var mapOverlayObj = {};
    switch (this.type) {
      case "circle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.lat = this.circleLat;
        mapOverlayObj.lng = this.circleLng;
        mapOverlayObj.rad = this.circleRad;

        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      case "polygon":
        mapOverlayObj.type = this.type;
        mapOverlayObj.arr = this.handleArrCreation(this.polygonArr);

        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      case "rectangle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.north = this.rectLat1;
        mapOverlayObj.south = this.rectLat2;
        mapOverlayObj.west = this.rectLng1;
        mapOverlayObj.east = this.rectLng2;

        obb.MapOverlay = JSON.stringify(mapOverlayObj);
        break;
      default:
        break;
    }

    this.validationCheck(obb.MapOverlay);
    if (name && customerId && timeZoneId && obb.MapOverlay) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Depots/DepotRegister`,
          obb,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          // this.props.history.push("/depots");
          this.props.history.goBack();
        }
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          const responseData = e.response && e.response.data;
          const validationErrors = responseData && responseData.errors
            ? Object.keys(responseData.errors).reduce((messages, key) => {
                return messages.concat(responseData.errors[key]);
              }, [])
            : [];
          const errorMessage =
            (responseData && (responseData.statusResponse || responseData.message)) ||
            validationErrors.join(" ") ||
            `${e}`;

          this.props.setErrorMessageAction(errorMessage);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = (obj) => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }

    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }

    if (!this.state.timeZoneId) {
      this.setState({ timeZoneError: true });
    }

    if (!obj) {
      this.setState({ mapOverlayError: true });
    }
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  // Map search and suggestions starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

    handleSearch = async () => {
        try {
            console.log("searec1", this.state.searchText);
            const { lat, lng } = await GeoCodeAPI(this.state.searchText);

            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });

            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

  handleSearchSuggestion = async (query) => {
    if (query != "") {
      this.setState({ suggestionVisibility: false });
    }
    this.setState({ suggestionVisibility: true });
      try {
          const items = await searchSuggestionAPI(query);
          this.setState({ suggestions: items });
      } catch (e) {
          console.log(e);
      }
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
    handleSuggestionClick = async (place) => {
        var nwlocation = place.replace("<b>", "");
        var location = nwlocation.replace("</b>", "");

        this.setState({ searchText: location, suggestionVisibility: false });
        try {
            const { lat, lng } = await GeoCodeAPI(location);

            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };
  // Map search and suggestions ends here

  render() {
    const {
      customers,
      timeZoneArr,
      customerName,
      timeZoneName,
      name,
      description,
      lat,
      lng,
      customerError,
      nameError,
      descriptionError,
      timeZoneError,
      mapOverlayError,
    } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Create Depot </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper depot-record-page">
              <div className="depot-record-header">
                <div>
                  <p className="depot-record-kicker">Depot creator</p>
                  <h2>{name || "Create Depot"}</h2>
                  <div className="depot-record-subtitle">
                    <span>{customerName || "Select customer"}</span>
                    <span>{timeZoneName || "Select time zone"}</span>
                    <span>{this.type ? `${this.type.charAt(0).toUpperCase()}${this.type.slice(1)} overlay` : "Select overlay"}</span>
                  </div>
                </div>
                <div className="depot-record-actions">
                  <Button variant="light" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Create Depot
                  </Button>
                </div>
              </div>

              <div className="depot-edit-layout">
                <Form className="depot-edit-form-modern">
                  <section className="depot-edit-section">
                    <div className="depot-edit-section-title">
                      <h3>Depot Details</h3>
                      <p>Customer ownership, depot name, timezone and description.</p>
                    </div>
                    <div className="depot-edit-grid">
                      <Form.Group className="depot-form-field" controlId="createDepotCustomer">
                        <Form.Label>Customer</Form.Label>
                        <Form.Control as="select" onChange={this.handleCustomer}>
                          <option value="default">Select Customer</option>
                          {customers.map((customer, index) => (
                            <option key={index}>{customer.name}</option>
                          ))}
                        </Form.Control>
                        {customerError && (
                          <p className="depot-field-error">The Customer field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field" controlId="createDepotTimeZone">
                        <Form.Label>Time Zone</Form.Label>
                        <Form.Control
                          as="select"
                          onChange={(e) => this.handleTimeZone(e)}
                        >
                          <option value="default">Select Time Zone</option>
                          {timeZoneArr.map((timezone, index) => (
                            <option key={index}>{timezone.timeZoneCity}</option>
                          ))}
                        </Form.Control>
                        {timeZoneError && (
                          <p className="depot-field-error">The Time Zone field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field" controlId="createDepotName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          onChange={this.handleName}
                          type="text"
                          value={name}
                        />
                        {nameError && (
                          <p className="depot-field-error">The Name field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field depot-edit-wide" controlId="createDepotDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows="4"
                          onChange={this.handleDescription}
                          value={description}
                        />
                        {descriptionError && (
                          <p className="depot-field-error">The Description field is required.</p>
                        )}
                      </Form.Group>

                      {this.state.error && (
                        <p className="error-text depot-save-error depot-edit-wide">
                          Please fill all the Required fields
                        </p>
                      )}
                    </div>
                  </section>

                  <section className="depot-edit-section depot-map-section">
                    <div className="depot-map-card-header">
                      <div>
                        <p className="depot-record-kicker">Map overlay</p>
                        <h3>Depot boundary</h3>
                        <p>Search for a location, then draw the depot geofence on the map.</p>
                      </div>
                      {mapOverlayError && (
                        <p className="depot-field-error">The Map field is required.</p>
                      )}
                    </div>
                    <div className="depot-record-card depot-map-card">
                      <div className="containerMapDepot">
                        <DepotMap
                          onCircleCreate={this.handleCircleCreate}
                          onPolygonCreate={this.handlePolygonCreate}
                          onRectangleCreate={this.handleRectangleCreate}
                          lat={lat}
                          lng={lng}
                        />
                        <div className="overlaySearch">
                          <Col sm="12" className="inputSuggestions">
                            <Form.Control
                              value={this.state.searchText}
                              onChange={(e) =>
                                this.handleLocationChange(e.target.value)
                              }
                              onKeyPress={(e) => this.handleKeyPress(e)}
                              autoComplete="off"
                              type="text"
                              placeholder="Search location"
                            />
                            {this.state.suggestionVisibility && (
                              <ul>
                                {this.state.suggestions &&
                                  this.state.suggestions.map((item) => {
                                    return (
                                      <li
                                        key={item.address.label}
                                        onClick={() =>
                                          this.handleSuggestionClick(item.address.label)
                                        }
                                      >
                                        <HtmlContent html={item.address.label} />
                                      </li>
                                    );
                                  })}
                              </ul>
                            )}
                          </Col>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="depot-record-actions depot-edit-actions">
                    <Button variant="light" onClick={this.handleBack}>
                      Back to List
                    </Button>
                    <Button variant="primary" onClick={this.handleCreate}>
                      Create Depot
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDepot);
